import React, { useState, useEffect } from 'react';
import { CgClose } from "react-icons/cg";
import { FaCloudUploadAlt } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import SummaryApi from '../common';
import { toast } from 'react-toastify';
import { FaEye } from 'react-icons/fa';
import { FaEyeSlash } from 'react-icons/fa';
import {  AiOutlineLoading3Quarters } from 'react-icons/ai';
import uploadImage from '../helpers/uploadImage';


const AddUser = ({ onClose, fetchData }) => {
  const [showPassword,setShowPassword] = useState(false)
    
  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
    profilePic: "",
    role: "",
    mobileNumber: "",
    type: "",
    isVerified: true,
    emailIsVerified: true,
  });

  const [typeOptions, setTypeOptions] = useState([]);
  const [loading, setLoading] = useState(false); 

  const handleUploadPic = async (e) => {
    const file = e.target.files[0];
    const uploadImageCloudinary = await uploadImage(file);
    setData((prev) => ({
      ...prev,
      profilePic: uploadImageCloudinary.url,
    }));
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;

    // If the role changes, update the type options
    if (name === 'role') {
      setData((prev) => ({
        ...prev,
        [name]: value,
        type: "", // Reset type when role changes
      }));

      if (value === 'ADMIN') {
        setTypeOptions(["Medicine", "Admin"]);
      } else if (value === 'SALESMAN') {
        setTypeOptions(["Medicine"]);
      } else {
        setTypeOptions([]);
      }
    } else {
      setData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleDeleteProfilePic = async () => {
    setData((prev) => ({
      ...prev,
      profilePic: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (/[^0-9]/.test(data.mobileNumber)) {
      toast.error('يجب أن يحتوى رقم الهاتف الجوال على أرقام فقط');
      return;
    }
  
    setLoading(true); 
  
    try {
      const response = await fetch(SummaryApi.addUser.url, {
        method: SummaryApi.addUser.method,
        credentials: 'include',
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify({
          data: data,
          email: data.email,
          password: data.password,
        }),
      });
  
      const responseData = await response.json();
  
      if (responseData.success) {
        setLoading(false);
        toast.success(responseData?.message);
        onClose();
        fetchData();
        
      } else {
        toast.error(responseData?.message);
      }
    } catch (error) {
      toast.error('حدث خطأ أثناء إضافة مستخدم جديد');
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    // Initialize type options based on the initial role
    if (data?.role === 'ADMIN') {
      setTypeOptions(["Medicine",  "Admin"]);
    } else if (data?.role === 'SALESMAN') {
      setTypeOptions(["Medicine"]);
    } else {
      setTypeOptions([]);
    }
  }, [data.role]);

  return (
    <div className='fixed w-full h-full bg-slate-200 bg-opacity-35 top-0 left-0 right-0 bottom-0 flex justify-center items-center'>
      <div className='bg-white p-4 rounded w-full max-w-2xl h-full max-h-[80%] overflow-hidden'>
        <div className='flex justify-between items-center pb-3'>
        <h2 className='font-bold text-lg text-center w-full'>
        إضافة مستخدم جديد
      </h2>
          <div className='w-fit ml-auto text-2xl hover:text-red-600 cursor-pointer' onClick={onClose}>
            <CgClose />
          </div>
        </div>

        <form className='grid p-4 gap-2 overflow-y-scroll h-full pb-5' onSubmit={handleSubmit}>
          <label htmlFor='name'>
            <span className='text-red-500 font-bold mr-1'>*</span>
            الاسم :
          </label>
          <input
            type='text'
            id='name'
            placeholder='ادخل الاسم'
            name='name'
            value={data.name}
            onChange={handleOnChange}
            className='p-2 bg-slate-100 border rounded'
            required
          />

          <label htmlFor='email'>
            <span className='text-red-500 font-bold mr-1'>*</span>
            عنوان البريد الإلكترونى :
          </label>
          <input
            type='text'
            id='email'
            placeholder='ادخل عنوان البريد الإلكترونى'
            name='email'
            value={data.email}
            onChange={handleOnChange}
            className='p-2 bg-slate-100 border rounded'
            required
          />

          <label htmlFor='mobileNumber'>
            <span className='text-red-500 font-bold mr-1'>*</span>
            رقم الهاتف الجوال :
          </label>
          <input
            type='text'
            id='mobileNumber'
            placeholder='ادخل رقم الهاتف الجوال'
            name='mobileNumber'
            value={data.mobileNumber}
            onChange={handleOnChange}
            className='p-2 bg-slate-100 border rounded'
            required
          />

          <label htmlFor='profilePic' className='mt-3'>الصورة الشخصية :</label>
          <div className='flex justify-center items-center'>
            {data.profilePic ? (
              <div className='relative'>
                <img
                  src={data.profilePic}
                  alt="Profile"
                  className='bg-slate-100 border cursor-pointer w-[120px] h-[120px] object-contain'
                />
                <div
                  className='absolute top-0 right-0 p-2 text-white bg-red-600 rounded-full cursor-pointer'
                  onClick={handleDeleteProfilePic}
                >
                  <MdDelete size={13} />
                </div>
              </div>
            ) : (
              <label htmlFor='uploadImageInput'>
                <div className='p-2 bg-slate-100 border rounded h-32 w-full flex justify-center items-center cursor-pointer'>
                  <div className='text-slate-500 flex justify-center items-center flex-col gap-2'>
                    <span className='text-4xl'><FaCloudUploadAlt /></span>
                    <p className='text-sm'>قم برفع الصورة الشخصية</p>
                    <input type='file' id='uploadImageInput' className='hidden' onChange={handleUploadPic} />
                  </div>
                </div>
              </label>
            )}
          </div>

          <label htmlFor='role' className='mt-3'>
            <span className='text-red-500 font-bold mr-1'>*</span>
            الصلاحيات :
          </label>
          <select
            id='role'
            name='role'
            value={data.role}
            onChange={handleOnChange}
            className='p-2 bg-slate-100 border rounded'
            required
          >
            <option value="">اختار صلاحية المستخدم</option>
            <option value="ADMIN">Admin</option>
            <option value="SALESMAN">SalesMan</option>
          </select>

          <label htmlFor='type' className='mt-3'>
            <span className='text-red-500 font-bold mr-1'>*</span>
            نوع المستخدم :
          </label>
          <select
            id='type'
            name='type'
            value={data.type}
            onChange={handleOnChange}
            className='p-2 bg-slate-100 border rounded'
            required
          >
            <option value="">اختار نوع المستخدم</option>
            {typeOptions.map((typeOption) => (
              <option key={typeOption} value={typeOption}>
                {typeOption}
              </option>
            ))}
          </select>

          <div>
          <label htmlFor='type' className='mt-3'>
            <span className='text-red-500 font-bold mr-1'>*</span>
            كلمة المرور :
          </label>
                            <div className='bg-slate-100 p-2 flex'>
                                <input 
                                    type={showPassword ? "text" : "password"} 
                                    placeholder='ادخل كلمة المرور'
                                    value={data.password}
                                    name='password' 
                                    onChange={handleOnChange}
                                    required
                                    className='w-full h-full outline-none bg-transparent'/>
                                <div className='cursor-pointer text-xl' onClick={()=>setShowPassword((preve)=>!preve)}>
                                    <span>
                                        {
                                            showPassword ? (
                                                <FaEye/>
                                            )
                                            :
                                            (
                                                <FaEyeSlash/>
                                            )
                                        }
                                    </span>
                                </div>
                            </div>
                        </div>
          <button
            type='submit'
            className={`w-full p-2 text-lg font-medium rounded ${loading ? 'bg-blue-300 cursor-not-allowed' : 'bg-blue-900 hover:bg-blue-700 active:bg-blue-700'} text-white`}
            disabled={loading}
          >
            {loading ? (
              <span className='flex justify-center items-center'>
                <AiOutlineLoading3Quarters/>
                جاري إضافة المستخدم الجديد...
              </span>
            ) : 'إضافة مستخدم جديد'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddUser;
